import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/Avatar';

import { RatingsStarsReview } from './RatingsStarsReview';
import './RatingsReviewer.scss';

export const RatingsReviewer = ({ name, profilePictureUrl, rating, timePassed }) => {
  return (
    <div className="grid__item 9/10 md-3/4 lg-3/4 ratings-reviewer__container">
      <Avatar name={name} url={profilePictureUrl} size={40} className="ratings-reviewer__avatar" />
      <div>
        <span className="ratings-reviewer__name">{name}</span>
        <RatingsStarsReview rating={rating} timePassed={timePassed} size="sm" />
      </div>
    </div>
  );
};

RatingsReviewer.propTypes = {
  name: PropTypes.string,
  profilePictureUrl: PropTypes.string,
  rating: PropTypes.number.isRequired,
  timePassed: PropTypes.string,
};
